/* eslint-disable react/prop-types */
import React, { memo, useEffect, useState } from "react";
import { Box, Switch, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";
import DatePicker from "react-flatpickr";
import SoftDatePicker from "components/SoftDatePicker";
import { Vietnamese } from "flatpickr/dist/l10n/vn";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  minWidth: 100,
};

const Td = ({ children, style, ...rest }) => {
  return (
    <td {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </td>
  );
};

function TaxPersonalTable({ setFieldValue }) {
  const [data, setData] = useState([
    {
      id: uuidV4(),
      value2: false,
      value3: "",
      value4: "",
      value5: "",
      value6: "",
      value7: "",
      value8: "",
      value9: "",
      value10: "",
      value11: "",
      value12: "",
      value13: "",
      value14: "",
      value15: "",
      value16: "",
      value17: "",
      value18: "",
      value19: "",
      value20: "",
    },
  ]);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { name, value } = values;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const handleAdd = () => {
    const newRow = {
      id: uuidV4(),
      value2: false,
      value3: "",
      value4: "",
      value5: "",
      value6: "",
      value7: "",
      value8: "",
      value9: "",
      value10: "",
      value11: "",
      value12: "",
      value13: "",
      value14: "",
      value15: "",
      value16: "",
      value17: "",
      value18: "",
      value19: "",
      value20: "",
    };
    setData((prev) => [...prev, newRow]);
  };

  const handleChangeValue = (id, name, value) => {
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };

  const handleDelete = (id) => {
    setData((prev) => prev.filter((item) => item.id !== id));
  };

  return (
    <Box display="flex" flexDirection="column" mt={1}>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td
                className="toggle-button"
                rowSpan={3}
                style={{ textAlign: "center", fontWeight: "bold", minWidth: 0 }}
              >
                STT
                <div className="button-action">
                  <button type="button" onClick={handleAdd}>
                    Thêm dòng
                  </button>
                </div>
              </Td>
              <Td rowSpan={3} style={{ textAlign: "center", fontWeight: "bold" }}>
                Chọn in
              </Td>
              <Td rowSpan={3} style={{ textAlign: "center", fontWeight: "bold" }}>
                Họ và tên (*)
              </Td>
              <Td rowSpan={3} style={{ textAlign: "center", fontWeight: "bold" }}>
                Mã số thuế (*)
              </Td>
              <Td rowSpan={3} style={{ textAlign: "center", fontWeight: "bold" }}>
                số CMND/Hộ chiếu
              </Td>
              <Td rowSpan={1} colSpan={3} style={{ textAlign: "center", fontWeight: "bold" }}>
                Thu nhập chịu thuế
              </Td>
              <Td rowSpan={2} colSpan={6} style={{ textAlign: "center", fontWeight: "bold" }}>
                Các khoản giảm trừ
              </Td>
              <Td rowSpan={3} style={{ textAlign: "center", fontWeight: "bold" }}>
                Thu nhập tính thuế
              </Td>
              <Td rowSpan={3} style={{ textAlign: "center", fontWeight: "bold" }}>
                Thuế TNCN phát sinh trong kỳ
              </Td>
              <Td rowSpan={3} style={{ textAlign: "center", fontWeight: "bold" }}>
                Số thuế TNCN đã khấu trừ
              </Td>
              <Td rowSpan={3} style={{ textAlign: "center", fontWeight: "bold" }}>
                Số thuế TNCN được giảm do làm việc trong KKT
              </Td>
              <Td rowSpan={3} style={{ textAlign: "center", fontWeight: "bold" }}>
                Thuế còn phải nộp
              </Td>
              <Td rowSpan={3} style={{ textAlign: "center", fontWeight: "bold" }}>
                Thuế nộp thừa đề nghị hoàn trả
              </Td>
              <Td rowSpan={3} style={{ textAlign: "center", fontWeight: "bold" }}>
                Phải quyết toán thuế?
              </Td>
            </tr>
            <tr>
              <Td rowSpan={2} style={{ textAlign: "center", fontWeight: "bold" }}>
                Tổng số
              </Td>
              <Td rowSpan={1} colSpan={2} style={{ textAlign: "center", fontWeight: "bold" }}>
                Trong đó: TNCT được giảm thuế
              </Td>
            </tr>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", fontWeight: "bold" }}>
                Làm việc trong KKT
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", fontWeight: "bold" }}>
                Theo Hiệp định
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", fontWeight: "bold" }}>
                Số người phụ thuộc
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", fontWeight: "bold" }}>
                Cho bản thân
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", fontWeight: "bold" }}>
                Cho những người phụ thuộc được giảm trừ
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", fontWeight: "bold" }}>
                Từ thiện, nhân đạo, khuyến học
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", fontWeight: "bold" }}>
                Bảo hiểm được trừ
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", fontWeight: "bold" }}>
                Quỹ hưu trí tự nguyện được trừ
              </Td>
            </tr>
            {data &&
              data.map((item, index) => (
                <tr key={item.id}>
                  <Td
                    className="toggle-button"
                    style={{ textAlign: "center", fontWeight: "bold", minWidth: 0 }}
                  >
                    {index + 1}
                    <div className="button-action delete">
                      <button type="button" onClick={() => handleDelete(item.id)}>
                        Xóa dòng
                      </button>
                    </div>
                  </Td>
                  <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                    <Switch
                      size="medium"
                      name="value2"
                      onChange={(e) => handleChangeValue(item.id, "value2", e.target.checked)}
                    />
                  </Td>
                  <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                    <InputTable
                      id={item.id}
                      type="text"
                      name="value3"
                      value={item.value3}
                      onChange={handleChange}
                    />
                  </Td>
                  <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                    <InputTable
                      id={item.id}
                      type="text"
                      name="value4"
                      value={item.value4}
                      onChange={handleChange}
                    />
                  </Td>
                  <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                    <InputTable
                      id={item.id}
                      type="text"
                      name="value5"
                      value={item.value5}
                      onChange={handleChange}
                    />
                  </Td>
                  <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                    <InputTable
                      id={item.id}
                      name="value6"
                      value={item.value6}
                      onChange={handleChange}
                    />
                  </Td>
                  <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                    <InputTable
                      id={item.id}
                      name="value7"
                      value={item.value7}
                      onChange={handleChange}
                    />
                  </Td>
                  <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                    <InputTable
                      id={item.id}
                      name="value8"
                      value={item.value8}
                      onChange={handleChange}
                    />
                  </Td>
                  <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                    <InputTable
                      id={item.id}
                      name="value9"
                      value={item.value9}
                      onChange={handleChange}
                    />
                  </Td>
                  <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                    <InputTable
                      id={item.id}
                      name="value10"
                      value={item.value10}
                      onChange={handleChange}
                    />
                  </Td>
                  <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                    <InputTable
                      id={item.id}
                      name="value11"
                      value={item.value11}
                      onChange={handleChange}
                    />
                  </Td>
                  <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                    <InputTable
                      id={item.id}
                      name="value12"
                      value={item.value12}
                      onChange={handleChange}
                    />
                  </Td>
                  <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                    <InputTable
                      id={item.id}
                      name="value13"
                      value={item.value13}
                      onChange={handleChange}
                    />
                  </Td>
                  <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                    <InputTable
                      id={item.id}
                      name="value14"
                      value={item.value14}
                      onChange={handleChange}
                    />
                  </Td>
                  <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                    <InputTable
                      id={item.id}
                      name="value15"
                      value={item.value15}
                      onChange={handleChange}
                    />
                  </Td>
                  <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                    <InputTable
                      id={item.id}
                      name="value16"
                      value={item.value16}
                      onChange={handleChange}
                    />
                  </Td>
                  <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                    <InputTable
                      id={item.id}
                      name="value17"
                      value={item.value17}
                      onChange={handleChange}
                    />
                  </Td>
                  <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                    <InputTable
                      id={item.id}
                      name="value18"
                      value={item.value18}
                      onChange={handleChange}
                    />
                  </Td>
                  <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                    <InputTable
                      id={item.id}
                      name="value19"
                      value={item.value19}
                      onChange={handleChange}
                    />
                  </Td>
                  <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                    <InputTable
                      id={item.id}
                      name="value20"
                      value={item.value20}
                      onChange={handleChange}
                    />
                  </Td>
                  <Td style={{ textAlign: "center", fontWeight: "bold" }}>Q</Td>
                </tr>
              ))}

            <tr>
              <Td
                colSpan={4}
                style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }}
              >
                Tổng cộng
              </Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }}></Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }}>0</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }}>0</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }}>0</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }}>0</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }}>0</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }}>0</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }}>0</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }}>0</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }}>0</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }}>0</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }}>0</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }}>0</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }}>0</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }}>0</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }}>0</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }}></Td>
            </tr>
          </tbody>
        </table>
      </Box>
    </Box>
  );
}

export default memo(TaxPersonalTable);

function InputTable(props) {
  const { onChange, type = "text", name, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    if (type === "text") {
      onChange({ value, name, type });
    } else {
      const newValue = value === "0" ? "" : value;
      if (!regexNumber.test(newValue)) return;
      onChange({ value: newValue !== "" ? +newValue : "", name, type });
    }
  }
  return (
    <input
      type={type}
      name={name}
      style={{
        textAlign: type === "text" ? "left" : "right",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.2rem 0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
